import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StockCode from './stock-code';
import InvestModal from './invest-modal';
import useFundStateStore from '../../common/fund-state-hook';

import { recordStatisticsEvent } from '../../../../services/statistics-service';
import { TriStateButton, CommonContainer, VFlex } from './styles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  & > a {
    margin-top: 26px;
    font-size: 19px;
    font-weight: ${props => props.theme.fontWeightHeavy};
    line-height: 120%;
    letter-spacing: -0.01em;
    text-align: center;
    width: 100%;
    max-width: ${props => ((!props.theme.isXXLarge && props.theme.isXLarge) ? 318 : 304)}px;

    ${props => props.theme.isMobileOrTablet && `
      max-width: unset;
    `};

    :hover {
      color: ${props => props.theme.primaryColor};
    }

    :before {
      content: "\uf0f6";
      font: ${props => props.theme.fontWeightDccc} 18px/1 FontAwesome,serif;
      margin-right: 8px;
    }
  }
`;

export default function WithUs({ fund, contact }) {
  const set = useFundStateStore(state => state.set);

  const showInvestModal = () => {
    set(state => {
      state.showInvestModal = true;
    });
  };

  const invest = e => {
    e && e.preventDefault();
    recordStatisticsEvent({
      id: fund.id,
      event: 'fund_profile_how_to_invest_clicked',
      statisticable: 'fund',
      clicked_url: fund.investUrl,
      page: window.location.pathname,
    });

    if (fund.fundType === 'Managed Fund') {
      window.open(fund.investUrl, '_blank', 'noopener,noreferrer');
    } else {
      showInvestModal();
    }
  };

  const pdsLinkClick = () => {
    recordStatisticsEvent({
      event: 'fund_profile_pds_clicked',
      statisticable: 'fund',
      id: fund.id,
      clicked_url: fund.pdsFileUrl,
      page: `${window.location.pathname}#investing-with`,
    });

    return false;
  };

  return (
    <CommonContainer>
      <VFlex>
        <em>invest with us</em>
        <p className="fund-title">
          <strong>{fund.name}</strong>
          {!!fund.stockCode && fund.fundType !== 'Managed Fund' && <StockCode code={fund.stockCode} exchange={fund.stockExchange} />}
        </p>
        <small>Find out how you can start investing today.</small>
      </VFlex>
      <Wrapper>
        <TriStateButton type="button" onClick={invest}>How To Invest</TriStateButton>
        {!!fund.pdsFileUrl && (
          <a href={fund.pdsFileUrl} target="_blank" rel="noopener noreferrer" onClick={pdsLinkClick}>
            Product Disclosure Statement
          </a>
        )}
        <InvestModal fund={fund} contact={contact} />
      </Wrapper>
    </CommonContainer>
  );
}

WithUs.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    fundType: PropTypes.string.isRequired,
    isin: PropTypes.string.isRequired,
    stockCode: PropTypes.string,
    stockExchange: PropTypes.string,
    fundPageUrl: PropTypes.string,
    pdsFileUrl: PropTypes.string.isRequired,
    investUrl: PropTypes.string,
  }).isRequired,
  contact: PropTypes.func.isRequired,
};
